import { render, staticRenderFns } from "./AccountRecycling.vue?vue&type=template&id=20d7016a&scoped=true&"
import script from "./AccountRecycling.vue?vue&type=script&lang=js&"
export * from "./AccountRecycling.vue?vue&type=script&lang=js&"
import style0 from "./AccountRecycling.vue?vue&type=style&index=0&id=20d7016a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d7016a",
  null
  
)

export default component.exports